import { AlignType } from '@email-editor/ui'
import { OptionButton } from '../../components/common/OptionButton'
import Option from '../../components/Option'

type AlignProps = {
  align: AlignType
  update: (value: AlignType) => void
  allowJustify?: boolean
}

function Align({ align, update }: AlignProps) {
  return (
    <Option label="settings_options.text_align.label">
      <div className="flex">
        <OptionButton selected={align === 'left'} onClick={() => update('left')}>
          <span className="fas fa-align-left" />
        </OptionButton>
        <OptionButton selected={align === 'center'} onClick={() => update('center')}>
          <span className="fas fa-align-center" />
        </OptionButton>
        <OptionButton selected={align === 'right'} onClick={() => update('right')}>
          <span className="fas fa-align-right" />
        </OptionButton>
      </div>
    </Option>
  )
}

export default Align
